import ReviewEntity from "@apps/reviews/entities/ReviewEntity";

import {
    ReviewItemCustomerSdkDto,
    ReviewItemImageSdkDto,
    ReviewItemProductSdkDto,
    ReviewItemReplySdkDto,
    ReviewItemSdkDto,
} from "../types";

function mapCustomer(
    customer: NonNullable<ReviewEntity["customer"]>
): ReviewItemCustomerSdkDto {
    return {
        name: customer.name,
    };
}

function mapImage(
    image: ReviewEntity["images"][number]
): ReviewItemImageSdkDto {
    return {
        url: image.url,
        sizes: image.sizes.map((size) => ({
            width: size.w,
            height: size.h,
            url: size.url,
        })),
    };
}

function mapProduct(
    product: NonNullable<ReviewEntity["product"]>
): ReviewItemProductSdkDto {
    return {
        id: product.id,
        isDeleted: product.isDeleted,
        isDraft: product.isDraft,
    };
}

function mapReply(
    reply: NonNullable<ReviewEntity["reply"]>
): ReviewItemReplySdkDto {
    return {
        body: reply.body,
        status: reply.status,
    };
}

export function mapReviewItemToSdkDto(review: ReviewEntity): ReviewItemSdkDto {
    return {
        id: review.id,
        uid: review.uid,
        rating: review.rating,
        title: review.title,
        body: review.body,
        customer: review.customer ? mapCustomer(review.customer) : null,
        createdAt: review.createdAt,
        images: review.images.map(mapImage),
        votes: review.votes,
        isCustomerVoted: review.isCustomerVoted,
        isPinned: review.isPinned,
        isIncentivized: review.isIncentivized,
        product: review.product ? mapProduct(review.product) : null,
        reply: review.reply ? mapReply(review.reply) : null,
        isPublished: review.isPublished,
        isCustomerAuthor: review.isCustomerAuthor,
        shopName: review.shopName,
    };
}
